import { Theme } from "@mui/material";

export const getSocialsStyles = (theme: Theme) => ({
  padding: 1.5,
  borderRadius: 2,
  border: "1px solid #D0D5DD",
  fontSize: 0,

  "& svg": {
    width: 20,
    height: 20,
    fill: theme.palette.grey[600],
    transition: "all 250ms ease-out",
  },

  "&:hover svg": {
    fill: theme.palette.primary.main,
  },
  "&:focus svg": {
    fill: theme.palette.primary.main,
  },
});

export const getLinkButtonStyles = (theme: Theme) => ({
  padding: 1.5,
  borderRadius: 2,
  border: "1px solid #D0D5DD",

  "& svg": {
    stroke: "#282828",
  },

  "&:hover svg": {
    stroke: theme.palette.primary.main,
  },
  "&:focus svg": {
    stroke: theme.palette.primary.main,
  },
});
